export default {"src":"/_next/static/image/public/images/ic_topbar_podium.fd8642de9c62ba143ee0bab90884730e.svg","height":368,"width":368};